"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppManifest = getAppManifest;
function getAppManifest(state) {
    if (state.appManifest.appManifest?.status === 'done') {
        if (state.appManifest.appManifest.data) {
            return state.appManifest.appManifest.data;
        }
        else {
            throw new Error('Invalid app manifest state, data is not set.');
        }
    }
    else {
        throw new Error('App manifest is not loaded.');
    }
}
